import React from "react"
const FaqFilter=(props)=>{

    return(
        <React.Fragment>
            <div className="container my-4" style={{padding:"25px", borderRadius:"15px",border:"1px solid rgb(219, 219, 219)"}}>
            <div className="row">
            <div className="col-6">
                <span className="d-inline-block"> جستجوی پرسش</span>
                <input type="text" className="form-control d-inline-block"  value={props.question} onChange={props.changeQuestion}/>
            </div>
            <div className="col-6">
                <span className="d-inline-block text-center"> جستجوی پاسخ</span>
                <input type="text" className="form-control d-inline-block" value={props.answer} onChange={props.changeAnswer}/>
            </div>
            <div className="col mt-4">
                <div className="btn btn-block btn-info" onClick={props.apply}>فیلتر </div>
            </div>
            </div>
            </div>
            |</React.Fragment>
        )
}
export default FaqFilter;